import { User } from "./User";
import { UserManager } from "./UserManager";

/**
	 * ...
	 * @author Rich
	 */
export class CopilotUserManager implements UserManager
{
    // State
    private _users : Array<User>;  // Vector of users stored by userId  
    
    constructor()
    {
        this._users = new Array<User>();
    }
    
    /**
		 * 
		 * State
		 * 
		**/
    
    /**
		 * @inheritDoc
		 */
    public get numUsers() : number
    {
        return this._users.length;
    }
    
    /**
		 * @inheritDoc
		 */
    public get userList() : Array<User>
    {
        // Cloning user vector; apparently concat returns a shallow clone if no args are provided.
        const users : Array<User> = [];

        for (const user of this._users)
        {
            users.push(user.clone());
        }
        return users;
    }
    
    /**
		 * @inheritDoc
		 */
    public get userIdArray() : Array<any>
    {
        const result : Array<any> = new Array<any>();
        
        // Converting user vector into an array.
        for (const user of this._users)
        {
            result.push(user.userId);
        }
        
        return result;
    }
    
    /**
		 * @inheritDoc
		 */
    public get userIdList() : Array<string>
    {
        const result : Array<string> = new Array<string>();
        
        for (const user of this._users)
        {
            result.push(user.userId);
        }
        
        return result;
    }
    
    /**
		 * @inheritDoc
		 */
    public get users()
    {
        // Convert the user vector to an object
        return this._users.reduce((acc: { [userId: string]: User }, user) => {
            acc[user.userId] = user;
            return acc;
        }, {});
    }
    
    /**
		 * 
		 * Existence
		 * 
		**/
    
    /**
		 * @inheritDoc
		 */
    public userExistsByUserId(userId : string) : boolean
    {
        const aUser : User = this.getUserByUserId(userId);
        return (aUser != null);
    }
    
    /**
		 * 
		 * Management
		 * 
		**/
    
    /**
		 * @inheritDoc
		 */
    public addUser(user : User) : void
    {
        if (user != null && !this._users.some(u => u === user))
        {
            this._users.push(user);
        }
    }
    
    private removeUserImpl(userId : string)
    {
        if (userId != null)
        {
            const i = this._users.findIndex(u => u.userId === userId);

            if (i > 0)
            {
                this._users.splice(i, 1);
            }
        }
    }

    /**
		 * @inheritDoc
		 */
    public removeUser(user : User) : void
    {
        this.removeUserImpl(user.userId);
    }

    public removeUserByUserId(userId : string)
    {
        this.removeUserImpl(userId);
    }
    
    /**
		 * 
		 * Retrieval
		 * 
		**/
    
    /**
		 * @inheritDoc
		 */
    public getUserByUserId(userId : string) : User
    {
        return this._users[this._users.findIndex(u => u.userId === userId)];
    }    
}

